import Select from "react-select";
import React, { useRef, useState } from "react";
import IGerencia from "../../entities/IGerencia";
import ISubContratista from "../../entities/ISubContratista";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import { getAPI, getAPIBatch } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserToken } from "../../helpers/userHelper";
import {
  API_ADMIN_CONTRATISTA_SUBCONTRATISTA,
  API_ADMIN_GERENCIA,
  API_ADMIN_UNIDAD,
  API_VPP,
  ROW_COUNT,
  URL_SUPPORT,
  ROW_COUNT_MAX,
} from "../../helpers/variableHelper";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { shortDate } from "../../helpers/dateHelper";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { ISearchReporteLIO, ISearchReporteSabanaLIO } from "../../entities/IInspeccionObservacion";
import LIOService from "../../services/LIOService";
import { cParamsActiveOrderTitle } from "../../helpers/paramsHelper";
import RenderValue from "../../controls/RenderValue";
import RenderTitle from "../../controls/RenderTitle";
const MySwal = withReactContent(Swal);

interface ReporteSabanaLIOtest {
  items?: Array<ISearchReporteLIO>;
  busqueda?: boolean;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbSubGerencia?: Array<IGerencia>;
  cbProyecto?: Array<IUnidad>;
  cbSubContratista?: Array<ISubContratista>;
  is_test?: boolean;
}

export default function ReporteSabanaLIO({
  is_test,
  items,
  busqueda,
  cbVicepresidencia,
  cbSubGerencia,
  cbProyecto,
  cbSubContratista,
}: ReporteSabanaLIOtest) {
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbSubGerencia || []);
  const [comboCSC, setComboCSC] = useState<Array<ISubContratista>>(cbSubContratista || []);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>(cbProyecto || []);
  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const [up, setUp] = useState<IComboboxOption | null>(null);
  const [cs, setCs] = useState<IComboboxOption | null>(null);
  const refNroDesviacion = React.createRef<HTMLInputElement>();
  const refFechaDeteccionDesde = React.createRef<HTMLInputElement>();
  const refFechaDeteccionHasta = React.createRef<HTMLInputElement>();
  const totalPageListDesviaciones = useRef<number>(0);
  const [listLIO, setListLIO] = useState<Array<ISearchReporteLIO>>(items || []);
  const [busquedaInicial, setBusquedaInicial] = useState(busqueda || false);
  const [filtrosColumnas, setFiltrosColumnas] = useState<ISearchReporteSabanaLIO>({
    ORDENADOPOR: "ID",
    ORIENTACION: "ASC",
    PAGINA: 1,
    PAGINADO: ROW_COUNT,
  });
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (info: any) => {
    return (
      <div>
        <i
          data-testid="test1"
          className="bi bi-search iconSearch"
          title="Ver Desviación"
          onClick={() => {
            window.location.href = `/agregarLIO?id=${info.row.original.ID}`;
          }}></i>
      </div>
    );
  };

  usePromiseEffect(async () => {
    await fillCombos();
    let token = await cognitoUserToken();
    setToken(token);
  }, []);
  const fillCombos = async () => {
    let urls = [`${URL_SUPPORT}${API_VPP}/getall`, `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`];
    let results = is_test ? [{ data: { data: [] } }] : await getAPIBatch(urls, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle);

    results.forEach((result, index) => {
      switch (index) {
        case 0:
          setComboVcc(result.data.data);
          break;
        case 1:
          setComboCSC(result.data.data);
          break;
      }
    });
  };

  const fillComboGSG = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const fillComboUP = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      NOMBRE_GERENCIA_SUBGERENCIA: vppId,
    };
    const comboGSG = (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboUP(comboGSG);
  };

  const handleValidacionBusqueda = (paramsBusqueda: ISearchReporteSabanaLIO) => {
    let arrErrors = [];
    if (
      !paramsBusqueda.CORRELATIVO &&
      !paramsBusqueda.VICEPRESIDENCIA &&
      !paramsBusqueda.GERENCIA_SUBGERENCIA &&
      !paramsBusqueda.UNIDAD_PROYECTO &&
      !paramsBusqueda.CONTRATISTA_SUBCONTRATISTA
    ) {
      if (!moment(paramsBusqueda?.FECHA_DESDE).isValid()) {
        arrErrors.push("Fecha desde válida");
      }
      if (!moment(paramsBusqueda?.FECHA_HASTA).isValid()) {
        arrErrors.push("Fecha hasta válida");
      }
    }
    if (moment(refFechaDeteccionDesde.current?.value) > moment(refFechaDeteccionHasta.current?.value)) {
      arrErrors.push("Fecha detección desde no puede ser superior a fecha hasta");
    }
    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Favor seleccione lo siguiente:</h3>
            {arrErrors.map((e) => (
              <p key={e}>{e}</p> //
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });

      return false;
    }
    return true;
  };
  const handleBuscar = async (pagination?: IPagination) => {
    let defaultPagination = pagination || {
      ...cParamsActiveOrderTitle,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `LIO."CORRELATIVO"`,
      ORIENTACION: "DESC NULLS LAST",
    };
    let paramsBusqueda: ISearchReporteSabanaLIO = {
      ...defaultPagination,
      NUMERO_INSPECCION: refNroDesviacion.current?.value,
      FECHA_DESDE: refFechaDeteccionDesde.current?.value ? refFechaDeteccionDesde.current?.value : null,
      FECHA_HASTA: refFechaDeteccionHasta.current?.value ? refFechaDeteccionHasta.current?.value : null,
      VICEPRESIDENCIA: vpp?.label,
      GERENCIA_SUBGERENCIA: gsg?.label,
      UNIDAD_PROYECTO: up?.label,
      CONTRATISTA_SUBCONTRATISTA: cs?.label,
    };
    if (handleValidacionBusqueda(paramsBusqueda)) {
      setBusquedaInicial(true);
      setIsLoading(true);
      let result = await LIOService.getListadoReporteSabanaLIO(token, {
        ...paramsBusqueda,
      });
      setListLIO(result.data);
      totalPageListDesviaciones.current = result.pages;
      setFiltrosColumnas(paramsBusqueda);
      setIsLoading(false);
    }
  };

  const handleLimpiarCampos = () => {
    (refNroDesviacion.current as HTMLInputElement).value = "";
    (refFechaDeteccionDesde.current as HTMLInputElement).value = "";
    (refFechaDeteccionHasta.current as HTMLInputElement).value = "";
    setVpp(null);
    setGsg(null);
    setUp(null);
  };

  const handleExportExcel = async () => {
    if (filtrosColumnas) {
      let filtrosColumnasExcel = {
        ...filtrosColumnas,
        ORDENADOPOR: `LIO."ID"`,
        ORIENTACION: "DESC NULLS LAST",
        PAGINA: 1,
        PAGINADO: ROW_COUNT_MAX,
      };
      let sendingEmail = await LIOService.getExcelReporteSabanaLIO(token, filtrosColumnasExcel);
      if (sendingEmail) {
        MySwal.fire({
          html: (
            <div>
              <h4>Se esta enviando un correo con el reporte solicitado.</h4>
              <div>En aprox. 5 minutos deberia poder verlo en su bandeja de correo, dependiendo de la cantidad de registros.</div>
            </div>
          ),
          icon: "info",
          confirmButtonText: "Aceptar",
          showCloseButton: true,
          showCancelButton: false,
        });
      }
    }
    setIsLoading(false);
  };

  const columnHelperDesvGeneradas = createColumnHelper<ISearchReporteSabanaLIO>();
  let columnsDefDesviaciones = [
    columnHelperDesvGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Número Lista"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.TIPO_LISTA, {
      id: "TIPO_LISTA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Lista"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.N_TRABAJO_REALIZADO, {
      id: "ATN",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("N° de Trabajo realizado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.TIPO_FAENA, {
      id: "TIPO_FAENA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Faena"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CONTRATISTA_CLIENTE, {
      id: "CONTRATISTA_SUBCONTRATISTA_COLUMNA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Contratista Cliente"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.INSTALACION_INTERVENIR, {
      id: "INSTALACION_INTERVENIR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Instalación a intervenir"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.JEFE_FAENA, {
      id: "JEFE_FAENA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Jefe Faena"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.INSPECCIONADO_POR, {
      id: "REQUISITO_NORMATIVO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Inspeccionado por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FAENA, {
      id: "HORARIO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Faena"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ENCARGADO_ZONAL, {
      id: "ENCARGADO_ZONAL",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Encargado Zonal"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.DETECTADO_POR, {
      id: "DETECTADO_POR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Detectado por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.CERRADO_POR, {
      id: "CERRADO_POR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Cerrado Por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Creación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Detección"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.OBSERVACION, {
      id: "OBSERVACION",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Observación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO_LISTA_LIO, {
      id: "ESTADO_LISTA_LIO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Estado Lista LIO"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASPECTO_DESVIADO, {
      id: "ASPECTO_DESVIADO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto Desviado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASPECTO_DESCRIPCION, {
      id: "ASPECTO_DESCRIPCION",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE, {
      id: "RESPONSABLE",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ACCION_A_REALIZAR, {
      id: "ACCION_A_REALIZAR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Acción a Realizar"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ACCION_REALIZADA, {
      id: "ACCION_REALIZADA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Acción Realizada"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_ACCION_REALIZADA, {
      id: "FECHA_ACCION_REALIZADA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_INGRESO_ACCION_REALIZADA, {
      id: "FECHA_INGRESO_ACCION_REALIZADA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Ingreso Acción Realizada"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO_ASPECTO, {
      id: "ESTADO_ASPECTO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Estado Aspecto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASPECTO_CERRADO_POR, {
      id: "ASPECTO_CERRADO_POR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Aspecto Cerrado Por"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.EMPRESA_INSPECTORA, {
      id: "EMPRESA_INSPECTORA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Empresa Inspectora"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.INSPECTOR, {
      id: "INSPECTOR",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Inspector"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.PREVENCIONISTA, {
      id: "PREVENCIONISTA",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Prevencionista"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.INTERNO_EXTERNO, {
      id: "INTERNO_EXTERNO",
      cell: (info: CellContext<ISearchReporteSabanaLIO, string>) => componentValue(info.getValue()),
      header: () => component("Interno/Externo"),
      tipo: ITipo_Campo.text,
    } as any),
  ] as any;

  return (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Reporte Sábana Inspección y Observación</h1>
            <div className="alert alert-warning p-1 mb-2" role="alert">
              <i className="text-info bi bi-info-circle-fill me-2"></i>
              <small>
                <strong>Nota:</strong> Este reporte permite consultar las Inspecciones realizadas en un período de tiempo.
              </small>
            </div>
            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label className="text-sm">Número de Inspección (ejemplo 350,351):</label>
                  <input
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Indique el número"
                    ref={refNroDesviacion}
                    onChange={(e: any) => {
                      let defaultPagination = {
                        ...cParamsActiveOrderTitle,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: `LIO."CORRELATIVO"`,
                        ORIENTACION: "DESC NULLS LAST",
                      };
                      let paramsBusqueda: ISearchReporteSabanaLIO = {
                        ...defaultPagination,
                        ...filtrosColumnas,
                        NUMERO_INSPECCION: refNroDesviacion.current?.value,
                      };
                      setFiltrosColumnas(paramsBusqueda);
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={
                      comboVcc.map((vcc) => ({
                        value: vcc.ID,
                        label: vcc.TITULO,
                      })) as any
                    }
                    placeholder="Seleccione"
                    value={vpp || ""}
                    isClearable={true}
                    onChange={(e: any) => {
                      setVpp(e || "");
                      fillComboGSG(e.label || "");
                      let defaultPagination = {
                        ...cParamsActiveOrderTitle,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: `LIO."CORRELATIVO"`,
                        ORIENTACION: "DESC NULLS LAST",
                      };
                      let paramsBusqueda: ISearchReporteSabanaLIO = {
                        ...defaultPagination,
                        ...filtrosColumnas,
                        VICEPRESIDENCIA: e.label,
                      };
                      setFiltrosColumnas(paramsBusqueda);
                    }}
                  />
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    options={
                      comboGSG.map((vcc) => ({
                        value: vcc.ID,
                        label: vcc.TITULO,
                      })) as any
                    }
                    placeholder="Seleccione"
                    value={gsg || ""}
                    isClearable={true}
                    onChange={(e: any) => {
                      setGsg(e || "");
                      fillComboUP(e.label || "");
                      let defaultPagination = {
                        ...cParamsActiveOrderTitle,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: `LIO."CORRELATIVO"`,
                        ORIENTACION: "DESC NULLS LAST",
                      };
                      let paramsBusqueda: ISearchReporteSabanaLIO = {
                        ...defaultPagination,
                        ...filtrosColumnas,
                        GERENCIA_SUBGERENCIA: e.label,
                      };
                      setFiltrosColumnas(paramsBusqueda);
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label>Unidad Proyecto:</label>
                  <Select
                    options={
                      comboUP.map((vcc) => ({
                        value: vcc.ID,
                        label: vcc.TITULO,
                      })) as any
                    }
                    placeholder="Seleccione"
                    value={up || ""}
                    isClearable={true}
                    onChange={(e: any) => {
                      setUp(e || "");
                      let defaultPagination = {
                        ...cParamsActiveOrderTitle,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: `LIO."CORRELATIVO"`,
                        ORIENTACION: "DESC NULLS LAST",
                      };
                      let paramsBusqueda: ISearchReporteSabanaLIO = {
                        ...defaultPagination,
                        ...filtrosColumnas,
                        UNIDAD_PROYECTO: e.label,
                      };
                      setFiltrosColumnas(paramsBusqueda);
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label>Contratistas/SubContratistas:</label>
                  <Select
                    options={
                      comboCSC.map((vcc) => ({
                        value: vcc.ID,
                        label: vcc.TITULO,
                      })) as any
                    }
                    placeholder="Seleccione"
                    value={cs || ""}
                    isClearable={true}
                    onChange={(e: any) => {
                      setCs(e || "");
                      let defaultPagination = {
                        ...cParamsActiveOrderTitle,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: `LIO."CORRELATIVO"`,
                        ORIENTACION: "DESC NULLS LAST",
                      };
                      let paramsBusqueda: ISearchReporteSabanaLIO = {
                        ...defaultPagination,
                        ...filtrosColumnas,
                        CONTRATISTA_SUBCONTRATISTA: e.label,
                      };
                      setFiltrosColumnas(paramsBusqueda);
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label className="text-sm">Fecha Desde (Detección)</label>
                  <div className="d-flex">
                    <input
                      className="form-control form-control-sm me-2"
                      type="date"
                      placeholder="Desde"
                      ref={refFechaDeteccionDesde}
                      onChange={(e: any) => {
                        let defaultPagination = {
                          ...cParamsActiveOrderTitle,
                          PAGINADO: ROW_COUNT,
                          ORDENADOPOR: `LIO."CORRELATIVO"`,
                          ORIENTACION: "DESC NULLS LAST",
                        };
                        let paramsBusqueda: ISearchReporteSabanaLIO = {
                          ...defaultPagination,
                          ...filtrosColumnas,
                          FECHA_DESDE: refFechaDeteccionDesde.current?.value ? refFechaDeteccionDesde.current?.value : null,
                        };
                        setFiltrosColumnas(paramsBusqueda);
                      }}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                  <label className="text-sm">Fecha Hasta (Detección)</label>
                  <div className="d-flex">
                    <input
                      className="form-control form-control-sm me-2"
                      type="date"
                      placeholder="Desde"
                      ref={refFechaDeteccionHasta}
                      onChange={(e: any) => {
                        let defaultPagination = {
                          ...cParamsActiveOrderTitle,
                          PAGINADO: ROW_COUNT,
                          ORDENADOPOR: `LIO."CORRELATIVO"`,
                          ORIENTACION: "DESC NULLS LAST",
                        };
                        let paramsBusqueda: ISearchReporteSabanaLIO = {
                          ...defaultPagination,
                          ...filtrosColumnas,
                          FECHA_HASTA: refFechaDeteccionHasta.current?.value ? refFechaDeteccionHasta.current?.value : null,
                        };
                        setFiltrosColumnas(paramsBusqueda);
                      }}
                    />
                  </div>
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => {
                      handleBuscar();
                    }}>
                    {" "}
                    <i className="bi bi-search me-2"></i> Buscar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-2"
                    onClick={() => {
                      handleLimpiarCampos();
                    }}>
                    {" "}
                    <i className="bi bi-trash me-2"></i>Limpiar Campos
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-success me-2"
                    onClick={() => {
                      setIsLoading(true);
                      handleExportExcel();
                    }}>
                    <i className="bi bi-file-earmark-excel"></i> Exportar Excel
                  </button>
                </div>
              </div>
            </div>

            <div className="" id="collapseGeneradas">
              <div className="card card-body border-0 p-0 mt-2">
                <div className="row">
                  <div className="col-12">
                    <div className="container-fluid mb-4">
                      <h1 className="titPrincipal colorTit mt-2"></h1>
                      <div className="row">
                        <div className="col-12 table-responsive bigTableReporte">
                          <div className="">
                            {busquedaInicial && (
                              <AdminListaPagination
                                defaultSortBy={`LIO."CORRELATIVO"`}
                                sortDirection="DESC NULLS LAST"
                                totalPages={totalPageListDesviaciones}
                                resultPerPage={ROW_COUNT}
                                callback={(pagination) => {
                                  handleBuscar(pagination);
                                }}
                                data={listLIO}
                                reload={() => {
                                  handleBuscar();
                                }}
                                columnsDef={columnsDefDesviaciones}
                                hideAdd={true}
                                hideExport={true}
                                isLoading={isLoading}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
